import React from 'react';
import { motion } from 'framer-motion';
import { contactDetails } from '../data/contactData';

export default function ContactInfo() {
  return (
    <div className="bg-gray-100 rounded-xl shadow-md p-10">
      <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">Get in Touch</h2>
      <p className="text-lg text-gray-600 text-center mb-8">
        Reach out to us for any inquiries or collaborations.
      </p>

      <div className="space-y-6">
        {contactDetails.map((detail, index) => (
          <motion.a
            key={detail.label}
            href={detail.link}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="flex items-center space-x-5 bg-white p-4 rounded-lg shadow-sm transition-all duration-300 hover:shadow-md"
          >
            {/* Icon */}
            <div className="p-3 rounded-full bg-green-100 text-green-600">
              <detail.icon className="h-6 w-6" />
            </div>

            {/* Text Details */}
            <div>
              <p className="text-sm font-semibold text-gray-500">{detail.label}</p>
              <p className="text-lg font-medium text-gray-900">{detail.value}</p>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
}
